import { useEffect, useMemo } from 'react'

import usePlayer from '../../../components/Player/usePlayer'

export default function useTeamPlayer(state) {
  const {
    deckDisabled,
    deckSlides,
    deckStatus,
    deckStatusProgress,
    recordingDeckTimestamps,
    recordingDisabled,
    recordingMedia,
    recordingMediaFormat,
    recordingStatus,
    recordingStatusProgress,
  } = state

  const isPlayerDisabled = useMemo(() => {
    return (
      (!deckDisabled && deckStatus !== 'success') ||
      (!recordingDisabled && recordingStatus !== 'success')
    )
  }, [deckDisabled, deckStatus, recordingDisabled, recordingStatus])

  const player = usePlayer({ isDisabled: isPlayerDisabled, ...state })

  const { setDeck, setIsDisabled, setRecording } = player

  useEffect(() => {
    setDeck({
      disabled: deckDisabled,
      slides: deckSlides,
      status: deckStatus,
      statusProgress: deckStatusProgress,
    })
  }, [deckDisabled, deckSlides, deckStatus, deckStatusProgress, setDeck])

  useEffect(() => {
    setRecording({
      deckTimestamps: recordingDeckTimestamps,
      disabled: recordingDisabled,
      media: recordingMedia,
      mediaFormat: recordingMediaFormat,
      status: recordingStatus,
      statusProgress: recordingStatusProgress,
    })
  }, [
    recordingDeckTimestamps,
    recordingDisabled,
    recordingMedia,
    recordingMediaFormat,
    recordingStatus,
    recordingStatusProgress,
    setRecording,
  ])

  useEffect(() => {
    setIsDisabled(isPlayerDisabled)
  }, [isPlayerDisabled, setIsDisabled])

  return player
}
